import React from 'react';

const SettersContext = React.createContext({
  setButtons: () => {},
  setSearch: () => {},
  setTree: () => {},
});

export default SettersContext;
